/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum BookingMethod {
  Unknown = 0,
  CallDriver = 1,
  CallOffice = 2,
  Online = 3,
  PhoneAtStop = 4,
  Text = 5,
}
